import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Badge,
  Button,
  InputGroup,
  Form,
  ButtonGroup,
} from "react-bootstrap";

function History() {
  const [filter, setFilter] = useState("all");

  // Mock Data
  const mockHistory = [
    {
      id: "BK-20260114-01",
      type: "Booking",
      date: "14/01/2026",
      time: "09:00 - 12:00",
      details: "Bàn T01 - Khu vực chung",
      guests: 2,
      total: 150000,
      status: "completed",
    },
    {
      id: "BK-20260121-02",
      type: "Booking",
      date: "21/01/2026",
      time: "14:00 - 16:00",
      details: "Phòng M01 - Phòng họp",
      guests: 6,
      total: 300000,
      status: "upcoming",
    },
    {
      id: "OD-20260110-05",
      type: "Order",
      date: "10/01/2026",
      time: "08:30",
      details: "2x Cà phê đen, 1x Bánh mì",
      guests: null,
      total: 85000,
      status: "completed",
    },
    {
      id: "BK-20260110-09",
      type: "Booking",
      date: "10/01/2026",
      time: "08:00 - 18:00",
      details: "Quiet Q02 - Góc yên tĩnh",
      guests: 1,
      total: 400000,
      status: "cancelled",
    },
  ];

  const getStatusInfo = (status) => {
    switch (status) {
      case "completed":
        return {
          text: "Hoàn thành",
          bg: "success",
          icon: "bi-check-circle-fill",
        };
      case "upcoming":
        return { text: "Sắp tới", bg: "primary", icon: "bi-clock-fill" };
      case "cancelled":
        return { text: "Đã hủy", bg: "danger", icon: "bi-x-circle-fill" };
      default:
        return { text: "N/A", bg: "secondary", icon: "bi-question-circle" };
    }
  };

  const filteredData =
    filter === "all"
      ? mockHistory
      : mockHistory.filter((item) => item.status === filter);

  return (
    <div
      style={{
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
        paddingBottom: "50px",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "40px 0",
          marginBottom: "30px",
          borderBottom: "1px solid #eee",
        }}
      >
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="fw-bold mb-0">Lịch sử hoạt động</h2>
            <ButtonGroup>
              <Button
                variant={filter === "all" ? "primary" : "outline-secondary"}
                onClick={() => setFilter("all")}
                style={
                  filter === "all"
                    ? { background: "#7367f0", border: "none" }
                    : {}
                }
              >
                Tất cả
              </Button>
              <Button
                variant={
                  filter === "upcoming" ? "primary" : "outline-secondary"
                }
                onClick={() => setFilter("upcoming")}
                style={
                  filter === "upcoming"
                    ? { background: "#7367f0", border: "none" }
                    : {}
                }
              >
                Sắp tới
              </Button>
              <Button
                variant={
                  filter === "completed" ? "primary" : "outline-secondary"
                }
                onClick={() => setFilter("completed")}
                style={
                  filter === "completed"
                    ? { background: "#7367f0", border: "none" }
                    : {}
                }
              >
                Hoàn thành
              </Button>
              <Button
                variant={
                  filter === "cancelled" ? "primary" : "outline-secondary"
                }
                onClick={() => setFilter("cancelled")}
                style={
                  filter === "cancelled"
                    ? { background: "#7367f0", border: "none" }
                    : {}
                }
              >
                Đã hủy
              </Button>
            </ButtonGroup>
          </div>

          <Row className="g-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text className="bg-white">
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control placeholder="Tìm kiếm theo mã đơn..." />
              </InputGroup>
            </Col>
            {/* Summary Stats */}
            <Col
              md={8}
              className="d-flex gap-4 justify-content-end align-items-center text-muted"
            >
              <span>
                <strong className="text-dark">Total:</strong>{" "}
                {mockHistory.length}
              </span>
              <span>
                <strong className="text-success">Completed:</strong>{" "}
                {mockHistory.filter((i) => i.status === "completed").length}
              </span>
              <span>
                <strong className="text-primary">Upcoming:</strong>{" "}
                {mockHistory.filter((i) => i.status === "upcoming").length}
              </span>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        {filteredData.length > 0 ? (
          filteredData.map((item) => {
            const statusInfo = getStatusInfo(item.status);
            const borderColor =
              item.status === "completed"
                ? "#28c76f"
                : item.status === "upcoming"
                ? "#7367f0"
                : "#ea5455";
            return (
              <Card
                key={item.id}
                className="shadow-sm mb-3 border-0"
                style={{
                  borderLeft: `5px solid ${borderColor}`,
                  transition: "all 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-3px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                <Card.Body className="p-4">
                  <Row className="align-items-center">
                    <Col md={1} className="text-center d-none d-md-block">
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          background:
                            item.type === "Booking" ? "#e3f2fd" : "#fff3e0",
                          color:
                            item.type === "Booking" ? "#2196f3" : "#ff9800",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "1.5rem",
                        }}
                      >
                        <i
                          className={`bi ${
                            item.type === "Booking"
                              ? "bi-calendar-check"
                              : "bi-cup-hot"
                          }`}
                        ></i>
                      </div>
                    </Col>
                    <Col md={5}>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <span
                          className="fw-bold fs-5"
                          style={{ color: "#5e5873" }}
                        >
                          {item.id}
                        </span>
                        <Badge bg="light" text="dark" className="border">
                          {item.type}
                        </Badge>
                      </div>
                      <h5 className="mb-1">{item.details}</h5>
                      <div className="text-muted small">
                        <i className="bi bi-calendar3 me-2"></i>
                        {item.date}
                        <span className="mx-2">|</span>
                        <i className="bi bi-clock me-2"></i>
                        {item.time}
                        {item.guests && (
                          <>
                            <span className="mx-2">|</span>
                            <i className="bi bi-people me-2"></i>
                            {item.guests} người
                          </>
                        )}
                      </div>
                    </Col>
                    <Col md={3} className="text-md-center my-3 my-md-0">
                      <Badge
                        bg={statusInfo.bg}
                        className="px-3 py-2 rounded-pill"
                      >
                        <i className={`bi ${statusInfo.icon} me-2`}></i>
                        {statusInfo.text}
                      </Badge>
                    </Col>
                    <Col md={3} className="text-md-end">
                      <div className="fw-bold fs-5 text-primary mb-2">
                        {new Intl.NumberFormat("vi-VN", {
                          style: "currency",
                          currency: "VND",
                        }).format(item.total)}
                      </div>
                      {item.status === "upcoming" && (
                        <div className="d-flex gap-2 justify-content-md-end">
                          <Button variant="outline-danger" size="sm">
                            Hủy
                          </Button>
                          <Button
                            variant="primary"
                            size="sm"
                            style={{ background: "#7367f0", border: "none" }}
                          >
                            Chi tiết
                          </Button>
                        </div>
                      )}
                      {item.status === "completed" && (
                        <div className="d-flex gap-2 justify-content-md-end">
                          <Button variant="outline-primary" size="sm">
                            Đặt lại
                          </Button>
                          <Button variant="outline-secondary" size="sm">
                            Hóa đơn
                          </Button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            );
          })
        ) : (
          <div className="text-center py-5">
            <img
              src="https://cdni.iconscout.com/illustration/premium/thumb/empty-state-2130362-1800926.png"
              alt="Empty"
              style={{ width: "200px", opacity: 0.5 }}
            />
            <h4 className="text-muted mt-3">Không tìm thấy lịch sử nào</h4>
          </div>
        )}
      </Container>
    </div>
  );
}

export default History;
